<div class="container-fluid pt-3">
  <div class="row mb-2 pt-2" style="display: flex; align-items: center">
    <div class="col-md-7 px-0 w-100">
      <p
        *ngIf="typeDePage == 'vehicule'"
        class="m-0 text-uppercase"
        style="font-size: 20px; color: #262756; font-weight: bold"
      >
        véhicules
      </p>
      <p
        *ngIf="typeDePage == 'conducteur'"
        class="m-0 text-uppercase"
        style="font-size: 20px; color: #262756; font-weight: bold"
      >
        conducteurs
      </p>

      <small
        *ngIf="typeDePage == 'vehicule'"
        class="text-uppercase"
        style="
          font-size: 15px;
          display: flex;
          align-items: center;
          color: #707070;
        "
      >
        <span
          class="cursor-pointer"
          [routerLink]="['/user/vehicule']"
          routerLinkActive="router-link-active"
          >liste des véhicules</span
        >
        <mat-icon>navigate_next</mat-icon
        ><span
          class="cursor-pointer"
          [routerLink]="['/user/vehicule/details/' + idVehicule]"
          routerLinkActive="router-link-active"
          >Détails véhicule ({{ unit }})</span
        >
        <mat-icon>navigate_next</mat-icon>Trajet véhicule ({{ trip_start }})
      </small>

      <small
        *ngIf="typeDePage == 'conducteur'"
        class="text-uppercase"
        style="
          font-size: 15px;
          display: flex;
          align-items: center;
          color: #707070;
        "
      >
        <span
          class="cursor-pointer"
          [routerLink]="['/user/conducteur']"
          routerLinkActive="router-link-active"
          >liste des conducteurs</span
        >
        <mat-icon>navigate_next</mat-icon
        ><span
          class="cursor-pointer"
          [routerLink]="['/user/conducteur/details/' + idConducteur]"
          routerLinkActive="router-link-active"
          >Détails conducteur ({{ unit }})</span
        >
        <mat-icon>navigate_next</mat-icon>Trajet conducteur ({{ trip_start }})
      </small>
    </div>
  </div>
  <ngx-spinner
    bdColor="rgba(100,112,124,0.56)"
    size="medium"
    color="#233547"
    type="ball-clip-rotate-multiple"
    [fullScreen]="true"
  >
    <p style="color: white"></p>
  </ngx-spinner>
  <div class="row pb-3">
    <div class="col-lg-6 col-xl-2 col-md-6 w-100 pr-0">
      <div class="export-icons d-flex mb-2">
        <div class="icn-sec">
          <img
            (click)="exportExcel(exportDirective, 'xlsx')"
            src="assets/newImages/excel-svg.svg"
          />
        </div>
        <div class="icn-sec">
          <img (click)="exportPDF()" src="assets/newImages/pdf-svg.svg" />
        </div>
      </div>
      <!--<div class="p-3 mb-2 headerZoom"
                style="zoom:0.9;    display: flex;
                                 align-items: center;height:80px !important;background: #323d415c;box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);border-radius: 6px">
                <div class="col-lg-12 col-xl-12 col-md-12 w-100">
                    <div class="row">





                        <mat-chip-list>

                            <mat-chip style="background: #1f1f20; color: #ffffff" selected (click)="getFilterChoise(1)">
                                1 jour
                            </mat-chip>


                            <mat-chip selected style="background: #fdd512; color: #ffffff" (click)="getFilterChoise(7)">
                                7
                                jours</mat-chip>


                            <mat-chip selected style="background: #237dbd; color: #ffffff"
                                (click)="getFilterChoise(14)">2
                                semaines
                            </mat-chip>


                            <mat-chip color="primary" selected (click)="getFilterChoise(30)">1 mois</mat-chip>
                        </mat-chip-list>

                    </div>
                </div>
            </div>!-->
    </div>
    <div class="col-lg-6 col-xl-3 mb-2 col-md-6 w-100 px-0">
      <div class="col-12 col-md-12 w-100">
        <div class="container-fluid">
          <div class="row rowposition px-0 pt-0" style="max-height: 182px">
            <div class="col-6">
              <div class="score-item">
                <img
                  class="safety_Score"
                  alt=""
                  placement="bottom"
                  ngbTooltip="Score de sécurité"
                  src="assets/newImages/security-svg.svg"
                />
                <div class="chart-infos">
                  <div class="d-flex justify-content-center mt-1">
                    <h4>{{ eco_score }}</h4>
                    <mat-icon
                      class="mt-2"
                      style="color: #262756"
                      *ngIf="eco_score_tendency == 1"
                    >
                      arrow_upward
                    </mat-icon>

                    <mat-icon
                      class="mt-2"
                      style="color: #262756"
                      *ngIf="eco_score_tendency == 0"
                    >
                      arrow_forward</mat-icon
                    >

                    <mat-icon
                      class="mt-2"
                      style="color: #262756"
                      *ngIf="eco_score_tendency == -1"
                    >
                      arrow_downward
                    </mat-icon>
                  </div>
                </div>
                <div class="chart-unit">
                  <h5>
                    {{ km_between_maneuvers }} <span> Entre les risques</span>
                  </h5>
                </div>
              </div>
            </div>

            <div class="col-6">
              <div class="score-item">
                <img
                  class="safety_score"
                  alt=""
                  placement="bottom"
                  ngbTooltip="Score d'économie"
                  src="assets/newImages/tree.svg"
                />
                <div class="chart-infos">
                  <div class="d-flex justify-content-center mt-1">
                    <h4>{{ safety_score }}</h4>
                    <mat-icon
                      class="mt-2"
                      style="color: #262756"
                      *ngIf="safety_score_tendency == 1"
                    >
                      arrow_upward
                    </mat-icon>

                    <mat-icon
                      class="mt-2"
                      style="color: #262756"
                      *ngIf="safety_score_tendency == 0"
                    >
                      arrow_forward</mat-icon
                    >

                    <mat-icon
                      class="mt-2"
                      style="color: #262756"
                      *ngIf="safety_score_tendency == -1"
                    >
                      arrow_downward
                    </mat-icon>
                  </div>
                </div>
                <div class="chart-unit">
                  <h5>{{ avg_idle_time }} <span>inactivité moyenne</span></h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-xl-12 col-md-12">
      <!-- zone Scores -->

      <div class="row">
        <!--  <div class="col-lg-12 pl-md-0 col-xl-4 col-md-12">

                    <div class="row pl-md-2">








                        <div class=" pl-2 pb-2  col-lg-6  col-xl-12 col-md-6">
                            <div class="d-flex pt-md-3 py-xl-3 pt-lg-3 pl-2"
                                style="    justify-content: center;background: #323d415c;box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);border-radius: 6px">
                                <img src="../../../../assets/core-img/safety_score.png" style="height: 34px;"
                                    placement="bottom" ngbTooltip="score sécurité" />
                                <p class=" px-3 mt-2 scoreFontFamily">{{eco_score}}% </p>
                                <div class="vr"></div>

                                <mat-icon class="mt-2" style="color: #4ca846b5;" *ngIf="(eco_score_tendency == 1 )">
                                    arrow_upward </mat-icon>

                                <mat-icon class="mt-2" style="color: #237dbdb0;" *ngIf="(eco_score_tendency == 0 )">
                                    arrow_forward</mat-icon>

                                <mat-icon class="mt-2" style="color: #e15b6b;" *ngIf="(eco_score_tendency == -1 )">
                                    arrow_downward </mat-icon>


                                <div class="vr"></div>
                                <p class=" px-3 mt-2 scoreFontFamily"> {{km_between_maneuvers}} </p>
                                <p class="scoreFontFamilyCommentaire">entre les risques</p>
                            </div>
                        </div>



                        <div class=" pl-2  pb-2 col-lg-6 col-xl-12 col-md-6">
                            <div class="d-flex pt-md-3 py-xl-3 pt-lg-3 pl-2"
                                style="    justify-content: center;background: #323d415c;box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);border-radius: 6px">

                                <img src="../../../../assets/core-img/eco_score.png" style="height: 34px;"
                                    placement="bottom" ngbTooltip="score d'économie" />
                                <p class="px-3 mt-2 scoreFontFamily">{{safety_score}}% </p>
                                <div class="vr"></div>


                                <mat-icon class="mt-2" style="color: #4ca846b5;" *ngIf="(safety_score_tendency == 1 )">
                                    arrow_upward </mat-icon>

                                <mat-icon class="mt-2" style="color: #237dbdb0;" *ngIf="(safety_score_tendency == 0 )">
                                    arrow_forward</mat-icon>

                                <mat-icon class="mt-2" style="color: #e15b6b;" *ngIf="(safety_score_tendency == -1 )">
                                    arrow_downward </mat-icon>


                                <div class="vr"></div>
                                <p class=" px-3 mt-2 scoreFontFamily">{{avg_idle_time}} </p>
                                <p class="scoreFontFamilyCommentaire">inactivité moyenne</p>
                            </div>
                        </div>

                        <div class="pl-2   mb-2   col-lg-12 col-xl-12 col-md-12">
                            <div class=" py-2 pl-2"
                                style="background: #323d415c; border-radius: 6px;    box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);">
                                <div class="col-md-12 w-100">
                                    <div class="row">
                                        <div class="col-6 col-md-2 w-100">
                                            <div style="
                                  cursor: pointer;
                                  border-radius: 7px;

                                  display: flex;
                                  justify-content: center;

                                " class="py-1">
                                                <img (click)="exportExcel(exportDirective, 'xlsx')"
                                                    src="https://img.icons8.com/color/48/000000/export-excel.png" />


                                            </div>
                                        </div>
                                        <div class="col-6 col-md-3 w-100">
                                            <div style="
                                  cursor: pointer;
                                  border-radius: 7px;

                                  display: flex;
                                  justify-content: center;

                                " class="py-1">
                                                <img (click)="exportExcel(exportDirective, 'csv')"
                                                    src="https://img.icons8.com/color/48/000000/export-csv.png" />

                                            </div>
                                        </div>
                                        <div class="col-6 col-md-2 w-100">
                                            <div style="
                                  cursor: pointer;
                                  border-radius: 7px;

                                  display: flex;
                                  justify-content: center;

                                " class="py-1">

                                                <img (click)="exportExcel(exportDirective, 'json')"
                                                    src="https://img.icons8.com/color/50/000000/json-download.png" />

                                            </div>
                                        </div>
                                        <div class="col-6 col-md-3 w-100">
                                            <div style="
                                  cursor: pointer;
                                  border-radius: 7px;

                                  display: flex;
                                  justify-content: center;

                                " class="py-1">

                                                <img (click)="exportExcel(exportDirective, 'txt')"
                                                    src="https://img.icons8.com/color/50/000000/rich-text-converter.png" />
                                            </div>
                                        </div>
                                        <div class="col-6 col-md-2 w-100">
                                            <div style="
                                  cursor: pointer;
                                  border-radius: 7px;

                                  display: flex;
                                  justify-content: center;

                                " class="py-1">
                                                <img src="https://img.icons8.com/color/48/000000/export-pdf.png" />

                                            </div>
                                        </div>
                                    </div>





                                </div>


                            </div>
                        </div>

                    </div>
                </div> -->

        <div class="col-lg-12 col-xl-6 col-md-12 pl-0">
          <div
            style="
              background: white;
              border-radius: 6px;
              box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28),
                -2.8px -2.8px 8px white,
                inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);
            "
          >
            <ul class="list-group" style="border-bottom: 1px solid #e9e0e0">
              <li class="list-group-item active" style="color: #ffffff">
                <img src="assets/newImages/distance.svg" />
                Détails de trajet ({{ unit }} -- {{ trip_start }} )
              </li>
            </ul>

            <div class="row px-4 pt-2">
              <table class="table table-hover" style="border-style: hidden">
                <thead class="d-none">
                  <tr class="d-none">
                    <th scope="col">Last</th>
                    <th scope="col">Handle</th>
                    <th scope="col">Last</th>
                    <th scope="col">Handle</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><b>Véhicule</b></td>
                    <td style="min-width: 200px; word-wrap: break-word">
                      {{ unit }}
                    </td>
                    <td><b>Conducteur</b></td>
                    <td style="word-wrap: break-word">
                      <p *ngIf="driver != null">{{ driver }}</p>
                      <p class="my-0" *ngIf="driver == null">--</p>
                    </td>
                  </tr>

                  <tr>
                    <td><b>Début</b></td>
                    <td style="min-width: 200px; word-wrap: break-word">
                      {{ trip_start }}
                    </td>
                    <td><b>Temps d'inactivité</b></td>
                    <td style="min-width: 200px; word-wrap: break-word">
                      {{ idle_time | formatTime }}
                    </td>
                  </tr>
                  <tr>
                    <td><b>Fin</b></td>
                    <td style="min-width: 200px; word-wrap: break-word">
                      {{ trip_end }}
                    </td>

                    <td><b>Vitesse moyenne</b></td>
                    <td style="min-width: 200px; word-wrap: break-word">
                      {{ avg_speed }} km/h
                    </td>
                  </tr>
                  <tr>
                    <td><b>Durée</b></td>
                    <td style="min-width: 200px; word-wrap: break-word">
                      {{ trip_duration | formatTime }}
                    </td>
                    <td><b>Vitesse maximum</b></td>
                    <td style="min-width: 200px; word-wrap: break-word">
                      {{ max_speed }} km/h
                    </td>
                  </tr>
                  <tr>
                    <td><b>Distance</b></td>
                    <td style="min-width: 200px; word-wrap: break-word">
                      {{ distance }} Km
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-xl-6 col-md-12 pl-0" style="height: 600px">
          <div class="controls">
            <button
              [ngClass]="{ typeMapIdSelected: typeMapIdSelect == 'satellite' }"
              (click)="changeTypeMap('satellite')"
              class="typeMapId"
            >
              satellite
            </button>
            <button
              [ngClass]="{ typeMapIdSelected: typeMapIdSelect == 'hybrid' }"
              (click)="changeTypeMap('hybrid')"
              class="typeMapId"
            >
              hybrid
            </button>
            <button
              [ngClass]="{ typeMapIdSelected: typeMapIdSelect == 'roadmap' }"
              (click)="changeTypeMap('roadmap')"
              class="typeMapId"
            >
              roadmap
            </button>
            <button
              [ngClass]="{ typeMapIdSelected: typeMapIdSelect == 'terrain' }"
              (click)="changeTypeMap('terrain')"
              class="typeMapId"
            >
              terrain
            </button>
          </div>
          <agm-map
            style="height: 50px"
            *ngIf="!simulation"
            [latitude]="lat"
            [longitude]="lng"
            [zoom]="zoom"
            [fullscreenControl]="true"
            [disableDefaultUI]="false"
            [zoomControl]="true"
            [mapTypeId]="typeMapIdSelect"
            [usePanning]="true"
            [streetViewControl]="true"
            [rotateControl]="true"
            [scaleControl]="true"
            (mapReady)="onMapReadyTraffic($event)"
          >
            <agm-marker-cluster
              (clusterClick)="onMouseOut(infoWindowcluster, $event)"
              [calculator]="calculateFunction"
              [styles]="clusterStyles"
            >
              <agm-info-window [disableAutoPan]="false" #infoWindowcluster>
              </agm-info-window>
              <div>
                <agm-marker
                  *ngFor="
                    let m of tableDataSource
                      | slice : 1 : tableDataSource?.length - 1;
                    let i = index
                  "
                  [latitude]="m.lat"
                  [longitude]="m.long"
                  [markerClickable]="true"
                  (markerClick)="
                    zoomPosition(m.lat, m.long, 30, infoWindow, $event)
                  "
                  [ngClass]="'first second'"
                  (mouseOver)="onMouseOver(infoWindow, $event)"
                  (mouseOut)="onMouseOut(infoWindow, $event)"
                  [iconUrl]="getIcon(m?.risk_score, m.maneuver_type)"
                >
                  <agm-info-window
                    [disableAutoPan]="false"
                    [isOpen]="isInfoWindowOpen(m.id)"
                    #infoWindow
                  >
                    <div class="row">
                      <div class="col-md-12">
                        <h1>{{ m?.maneuver_type }}</h1>
                        <hr style="border-bottom: 1px solid #262756" />
                      </div>

                      <div *ngIf="m.risk_score != null" class="col-md-12">
                        <div
                          class="pt-2 mb-2 d-flex"
                          style="justify-content: center; border-radius: 6px"
                          [ngClass]="{ score_inactive: m.risk_score == 0 , score_green : m.risk_score &lt; 101 , score_orange : m.risk_score &lt; 76 ,  score_red : m.risk_score &lt; 55 }"
                        >
                          <img
                            src="../../../../assets/core-img/safety_score.png"
                            style="height: 32px"
                          />
                          <p class="px-1 mr-2 scoreFontFamilymap">
                            {{ m.risk_score }}%
                          </p>
                          <p class="scoreFontFamilyCommentairemap">
                            Score sécurité
                          </p>
                        </div>
                      </div>
                    </div>

                    <table class="container">
                      <tbody>
                        <tr *ngIf="m.maneuver_type === 'Accident'">
                          <td>Type d'accident :</td>
                          <td>{{ m.crash_type }}</td>
                        </tr>
                        <tr *ngIf="m.maneuver_type === 'Accident'">
                          <td>Orientation :</td>
                          <td>{{ m.orientation }}</td>
                        </tr>
                        <tr *ngIf="m.maneuver_type === 'Accident'">
                          <td>Parking :</td>
                          <td>{{ m.parking }}</td>
                        </tr>
                        <tr>
                          <td>Début :</td>
                          <td>{{ m.maneuver_start }}</td>
                        </tr>
                        <tr>
                          <td>Fin :</td>
                          <td>{{ m.maneuver_end }}</td>
                        </tr>

                        <tr>
                          <td>Vitesse max :</td>
                          <td>{{ m.max_speed }} Km/h</td>
                        </tr>
                        <tr>
                          <td>Vitesse moy :</td>
                          <td>{{ m.avg_speed }} Km/h</td>
                        </tr>
                        <tr>
                          <td>Durée :</td>
                          <td>{{ m.maneuver_duration | formatTime }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </agm-info-window>
                </agm-marker>
              </div>
            </agm-marker-cluster>
            <div *ngFor="let m of tableDataSource; let i = index">
              <div>
                <agm-marker
                  [iconUrl]="iconStart"
                  *ngIf="i === 0"
                  [latitude]="m.lat"
                  [longitude]="m.long"
                  [markerClickable]="true"
                  (markerClick)="
                    zoomPosition(m.lat, m.long, 30, infoWindow, $event)
                  "
                  (mouseOver)="onMouseOver(infoWindow, $event)"
                  (mouseOut)="onMouseOut(infoWindow, $event)"
                >
                  <agm-info-window [disableAutoPan]="false" #infoWindow>
                    <div class="row">
                      <div class="col-md-12">
                        <h1>{{ m?.maneuver_type }}</h1>

                        <hr style="border-bottom: 1px solid #262756" />
                      </div>

                      <div *ngIf="m.risk_score != null" class="col-md-12">
                        <div
                          class="pt-2 mb-2 d-flex"
                          style="justify-content: center; border-radius: 6px"
                          [ngClass]="{ score_inactive: m.risk_score == 0 , score_green : m.risk_score &lt; 101 , score_orange : m.risk_score &lt; 76 ,  score_red : m.risk_score &lt; 55 }"
                        >
                          <img
                            style="height: 32px"
                            src="../../../../assets/core-img/safety_score.png"
                            alt=""
                          />
                          <p class="px-1 mr-2 scoreFontFamilymap">
                            {{ m.risk_score }}%
                          </p>

                          <p class="scoreFontFamilyCommentairemap">
                            Score sécurité
                          </p>
                        </div>
                      </div>
                    </div>

                    <table class="container">
                      <tbody>
                        <tr *ngIf="m.maneuver_type === 'Accident'">
                          <td>Type d'accident :</td>
                          <td>{{ m.crash_type }}</td>
                        </tr>
                        <tr *ngIf="m.maneuver_type === 'Accident'">
                          <td>Orientation :</td>
                          <td>{{ m.orientation }}</td>
                        </tr>
                        <tr *ngIf="m.maneuver_type === 'Accident'">
                          <td>Parking :</td>
                          <td>{{ m.parking }}</td>
                        </tr>
                        <tr>
                          <td>Début :</td>
                          <td>{{ m.maneuver_start }}</td>
                        </tr>
                        <tr>
                          <td>Fin :</td>
                          <td>{{ m.maneuver_end }}</td>
                        </tr>

                        <tr>
                          <td>Vitesse max :</td>
                          <td>
                            {{ m.max_speed ? m.max_speed + " Km/h" : "--" }}
                          </td>
                        </tr>
                        <tr>
                          <td>Vitesse moy :</td>
                          <td>
                            {{ m.avg_speed ? m.avg_speed + " Km/h" : "--" }}
                          </td>
                        </tr>
                        <tr>
                          <td>Durée :</td>
                          <td>{{ m.maneuver_duration | formatTime }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </agm-info-window>
                </agm-marker>

                <agm-marker
                  [iconUrl]="iconEnd"
                  *ngIf="i == tableDataSource.length - 1"
                  [latitude]="m.lat"
                  [longitude]="m.long"
                  [markerClickable]="true"
                  (markerClick)="
                    zoomPosition(m.lat, m.long, 30, infoWindow, $event)
                  "
                  (mouseOver)="onMouseOver(infoWindow, $event)"
                  (mouseOut)="onMouseOut(infoWindow, $event)"
                >
                  <agm-info-window [disableAutoPan]="false" #infoWindow>
                    <div class="row">
                      <div class="col-md-12">
                        <h1>{{ m?.maneuver_type }}</h1>
                        <hr style="border-bottom: 1px solid #262756" />
                      </div>

                      <div *ngIf="m.risk_score != null" class="col-md-12">
                        <div
                          class="pt-2 mb-2 d-flex"
                          style="justify-content: center; border-radius: 6px"
                          [ngClass]="{ score_inactive: m.risk_score == 0 , score_green : m.risk_score &lt; 101 , score_orange : m.risk_score &lt; 76 ,  score_red : m.risk_score &lt; 55 }"
                        >
                          <img
                            style="height: 32px !important"
                            src="../../../../assets/core-img/safety_score.png"
                            alt=""
                          />
                          <p class="px-1 mr-2 scoreFontFamilymap">
                            {{ m.risk_score }}%
                          </p>

                          <p class="scoreFontFamilyCommentairemap">
                            Score sécurité
                          </p>
                        </div>
                      </div>
                    </div>
                    <table class="container">
                      <tbody>
                        <tr *ngIf="m.maneuver_type === 'Accident'">
                          <td>Type d'accident :</td>
                          <td>{{ m.crash_type }}</td>
                        </tr>
                        <tr *ngIf="m.maneuver_type === 'Accident'">
                          <td>Orientation :</td>
                          <td>{{ m.orientation }}</td>
                        </tr>
                        <tr *ngIf="m.maneuver_type === 'Accident'">
                          <td>Parking :</td>
                          <td>{{ m.parking }}</td>
                        </tr>
                        <tr>
                          <td>Début :</td>
                          <td>{{ m.maneuver_start }}</td>
                        </tr>
                        <tr>
                          <td>Fin :</td>
                          <td>{{ m.maneuver_end }}</td>
                        </tr>

                        <tr>
                          <td>Vitesse max :</td>
                          <td>
                            {{ m.max_speed ? m.max_speed + " Km/h" : "--" }}
                          </td>
                        </tr>
                        <tr>
                          <td>Vitesse moy :</td>
                          <td>
                            {{ m.avg_speed ? m.avg_speed + " Km/h" : "--" }}
                          </td>
                        </tr>
                        <tr>
                          <td>Durée :</td>
                          <td>{{ m.maneuver_duration | formatTime }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </agm-info-window>
                </agm-marker>
              </div>
            </div>

            <agm-polyline
              [visible]="true"
              [strokeColor]="'#4285f4'"
              [strokeOpacity]="0.9"
            >
              <agm-icon-sequence
                [fixedRotation]="false"
                [repeat]="'100px'"
                [offset]="100"
                [path]="'FORWARD_CLOSED_ARROW'"
              >
              </agm-icon-sequence>

              <agm-polyline-point
                *ngFor="let m of markers; let i = index"
                [latitude]="m.lat"
                [longitude]="m.long"
              >
              </agm-polyline-point>
            </agm-polyline>
          </agm-map>

          <div *ngIf="simulation" class="controlsOptions">
            <button
              placement="bottom"
              ngbTooltip="Lent"
              mat-mini-fab
              style="background-color: white"
              (click)="slow()"
            >
              <mat-icon>fast_rewind</mat-icon>
            </button>
            &nbsp;
            <button
              placement="bottom"
              ngbTooltip="Play"
              mat-mini-fab
              style="background-color: white"
              (click)="play()"
            >
              <mat-icon>play_circle_outline</mat-icon>
            </button>
            &nbsp;
            <button
              placement="bottom"
              ngbTooltip="Pause"
              mat-mini-fab
              style="background-color: white"
              (click)="pause()"
            >
              <mat-icon>pause_circle_outline</mat-icon>
            </button>
            &nbsp;
            <button
              placement="bottom"
              ngbTooltip="Réinitialiser"
              mat-mini-fab
              style="background-color: white"
              (click)="reset()"
            >
              <mat-icon> format_color_reset</mat-icon>
            </button>
            &nbsp;
            <button
              placement="bottom"
              ngbTooltip="Précédent"
              mat-mini-fab
              style="background-color: white"
              (click)="prev()"
            >
              <mat-icon>skip_previous</mat-icon>
            </button>
            &nbsp;
            <button
              placement="bottom"
              ngbTooltip="Suivant"
              mat-mini-fab
              style="background-color: white"
              (click)="next()"
            >
              <mat-icon>skip_next</mat-icon>
            </button>
            &nbsp;
            <button
              placement="bottom"
              ngbTooltip="Rapide"
              mat-mini-fab
              style="background-color: white"
              (click)="fast()"
            >
              <mat-icon>fast_forward</mat-icon></button
            >&nbsp;

            <button
              placement="bottom"
              ngbTooltip="Lent"
              mat-mini-fab
              style="background-color: white"
              (click)="slow()"
            >
              <span id="speed" style="color: #3b5876"
                >{{ speedMultiplier }}x</span
              >
            </button>
            &nbsp;
          </div>
        </div>
      </div>

      <hr />
      <!-- zone tableau -->

      <div class="row mb-3">
        <div class="col-lg-2 col-xl-2 col-md-2 w-100 pl-md-0"></div>

        <div class="col-lg-2 col-xl-2 col-md-2 w-100 pl-0"></div>
        <div class="col-lg-1 col-xl-2 col-md-1 w-100"></div>
        <div
          class="col-lg-1 col-xl-3 col-md-1 w-100 pl-0 d-flex"
          style="justify-content: flex-end; padding: 0px"
        >
          <button
            *ngIf="simulationAccident"
            placement="top"
            ngbTooltip="Reconstruction de l'accident"
            (click)="openDialog()"
            mat-fab
            style="
              background-color: white !important;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <img
              src="https://img.icons8.com/officel/35/000000/treasure-map.png"
            />
          </button>
        </div>
        <div class="col-lg-6 col-xl-3 col-md-6 mb-2 w-100"></div>
      </div>

      <div class="row" style="padding-right: 15px !important">
        <div class="example-container mat-elevation-z8">
          <mat-table
            #table
            #exportDirective="matTableExporter"
            matTableExporter
            [dataSource]="dataSource"
            matSort
          >
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>ID.</th>
              <td
                (click)="
                  getPositionCrash(
                    element.maneuver_type,
                    element?.orientation,
                    element?.crash_type,
                    element?.parking,
                    element?.crash_id
                  )
                "
                [ngClass]="{ clickItemTable: element?.id == selectedRowIndex }"
                mat-cell
                *matCellDef="let element"
              >
                {{ element?.id }}
              </td> </ng-container
            >F
            <ng-container matColumnDef="Manoeuvres">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Manoeuvres
              </th>
              <td
                style="padding-left: 36px !important"
                (click)="
                  getPositionCrash(
                    element.maneuver_type,
                    element?.orientation,
                    element?.crash_type,
                    element?.parking,
                    element?.crash_id
                  )
                "
                [ngClass]="{ clickItemTable: element?.id == selectedRowIndex }"
                mat-cell
                *matCellDef="let element"
              >
                <img
                  [src]="
                    getIcon(element?.risk_score, element?.maneuver_type).url
                  "
                  width="18%"
                  height="18%"
                  alt=""
                /></td
            ></ng-container>

            <ng-container matColumnDef="maneuver_start">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
              <td
                (click)="
                  getPositionCrash(
                    element.maneuver_type,
                    element?.orientation,
                    element?.crash_type,
                    element?.parking,
                    element?.crash_id
                  )
                "
                [ngClass]="{ clickItemTable: element?.id == selectedRowIndex }"
                mat-cell
                *matCellDef="let element"
                [style.color]="element.typeExport"
              >
                {{ element.maneuver_start }}
              </td>
            </ng-container>

            <ng-container matColumnDef="maneuver_type">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Information
              </th>
              <td
                (click)="
                  getPositionCrash(
                    element.maneuver_type,
                    element?.orientation,
                    element?.crash_type,
                    element?.parking,
                    element?.crash_id
                  )
                "
                [ngClass]="{ clickItemTable: element?.id == selectedRowIndex }"
                mat-cell
                *matCellDef="let element"
              >
                {{ element?.maneuver_type }}
              </td></ng-container
            >

            <ng-container matColumnDef="avg_speed">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Vitesse moy
              </th>
              <td
                (click)="
                  getPositionCrash(
                    element.maneuver_type,
                    element?.orientation,
                    element?.crash_type,
                    element?.parking,
                    element?.crash_id
                  )
                "
                [ngClass]="{ clickItemTable: element?.id == selectedRowIndex }"
                mat-cell
                *matCellDef="let element"
              >
                <p
                  *ngIf="
                    !(
                      element?.maneuver_type === 'Inactivité' ||
                      element?.maneuver_type === 'Accident'
                    )
                  "
                >
                  {{ element.avg_speed }}km/h
                </p>
                <p
                  class="my-0 py-3"
                  *ngIf="
                    element?.maneuver_type === 'Inactivité' ||
                    element?.maneuver_type === 'Accident'
                  "
                >
                  --
                </p>
              </td>
            </ng-container>

            <ng-container matColumnDef="max_speed">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Vitesse max
              </th>
              <td
                (click)="
                  getPositionCrash(
                    element.maneuver_type,
                    element?.orientation,
                    element?.crash_type,
                    element?.parking,
                    element?.crash_id
                  )
                "
                [ngClass]="{ clickItemTable: element?.id == selectedRowIndex }"
                mat-cell
                *matCellDef="let element"
                (contextmenu)="onContextMenu($event, element)"
              >
                <p
                  *ngIf="
                    !(
                      element?.maneuver_type === 'Inactivité' ||
                      element?.maneuver_type === 'Accident'
                    )
                  "
                >
                  {{ element.max_speed }}km/h
                </p>
                <p
                  class="my-0 py-3"
                  *ngIf="
                    element?.maneuver_type === 'Inactivité' ||
                    element?.maneuver_type === 'Accident'
                  "
                >
                  --
                </p>
              </td>
            </ng-container>

            <ng-container matColumnDef="maneuver_duration">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Durée</th>
              <td
                (click)="
                  getPositionCrash(
                    element.maneuver_type,
                    element?.orientation,
                    element?.crash_type,
                    element?.parking,
                    element?.crash_id
                  )
                "
                [ngClass]="{ clickItemTable: element?.id == selectedRowIndex }"
                mat-cell
                *matCellDef="let element"
                (contextmenu)="onContextMenu($event, element)"
              >
                {{ element.maneuver_duration | formatTime }}
              </td>
            </ng-container>
            <ng-container matColumnDef="risk_score">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Score</th>
              <td
                (click)="
                  getPositionCrash(
                    element.maneuver_type,
                    element?.orientation,
                    element?.crash_type,
                    element?.parking,
                    element?.crash_id
                  )
                "
                [ngClass]="{ clickItemTable: element.id == selectedRowIndex }"
                mat-cell
                *matCellDef="let element"
                (contextmenu)="onContextMenu($event, element)"
              >
                <circle-progress
                  *ngIf="
                    !(
                      element?.maneuver_type === 'Inactivité' ||
                      element?.maneuver_type === 'Accident'
                    )
                  "
                  [percent]="element?.risk_score"
                  [radius]="25"
                  [outerStrokeWidth]="2"
                  [innerStrokeWidth]="1"
                  [outerStrokeColor]="updateColor(element?.risk_score)"
                  [innerStrokeColor]="updateColor(element?.risk_score)"
                  [animationDuration]="200"
                  [showSubtitle]="false"
                  [titleFontSize]="11"
                ></circle-progress>
                <p
                  class="my-0 py-3"
                  *ngIf="
                    element?.maneuver_type === 'Inactivité' ||
                    element?.maneuver_type === 'Accident'
                  "
                >
                  --
                </p>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              (click)="openWindow(row.id, row.lat, row.long)"
              (click)="selection.toggle(row)"
            ></tr>
            <tr *matNoDataRow>
              <td class="w-100">
                <p class="mt-3">Il n'y a aucune manœuvre pour le moment.</p>
              </td>
            </tr>
          </mat-table>
        </div>
      </div>
      <mat-paginator
        #paginator
        [pageSize]="15"
        (page)="pageChanged($event)"
        [pageSizeOptions]="[15, 30, 100]"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </div>
</div>
